import { fabric } from 'fabric';
import { DEFAULT_MINIMUM_POINT, FABRIC_CUSTOM_OBJECT } from '../utils';
import { getIndex } from './container';
import { getPathStringFromPoints, removeId, state4Port, updateConnector } from './fabric_flowchart';
import { addingControlPoints, deleteControl } from './lineControl';

export const isModifiableArrowLine = (obj) =>
  obj?.name === FABRIC_CUSTOM_OBJECT.modifiableArrowLine ||
  obj?.originalName === FABRIC_CUSTOM_OBJECT.modifiableArrowLine;

export const highlightObjId = { id: null };
let highlightObj = new fabric.Polyline(
  [
    { x: 1, y: 1 },
    { x: 1, y: 1 },
  ],
  {},
);
let listLabel = [];

const polylineSelectedId = { id: null };
let highlightObjSelected = new fabric.Polyline(
  [
    { x: 1, y: 1 },
    { x: 1, y: 1 },
  ],
  {},
);
let listLabelSelected = [];

export function updatePoints(polyline) {
  let minX = DEFAULT_MINIMUM_POINT;
  let minY = DEFAULT_MINIMUM_POINT;
  let minLineY = DEFAULT_MINIMUM_POINT;
  let minLineX = DEFAULT_MINIMUM_POINT;
  let minHeadY = DEFAULT_MINIMUM_POINT;
  let minHeadX = DEFAULT_MINIMUM_POINT;
  let updatePolyline = polyline;
  if (isModifiableArrowLine(polyline) && !polyline?._objects) return polyline;
  if (isModifiableArrowLine(polyline)) {
    updatePolyline = polyline._objects.find((o) => o?.name === FABRIC_CUSTOM_OBJECT.modifiableArrowLine);
    updatePolyline.points.forEach((e) => {
      minX = Math.min(e.x, minX);
      minY = Math.min(e.y, minY);
    });
    polyline._objects.forEach((e) => {
      if (e?.name !== FABRIC_CUSTOM_OBJECT.modifiableArrowLine) {
        minHeadX = Math.min(e?.getBoundingRect()?.left, minHeadX);
        minHeadY = Math.min(e?.getBoundingRect()?.top, minHeadY);
      } else {
        minLineX = Math.min(e?.getBoundingRect()?.left, minLineX);
        minLineY = Math.min(e?.getBoundingRect()?.top, minLineY);
      }
    });
  } else {
    updatePolyline.points.forEach((e) => {
      minX = Math.min(e.x, minX);
      minY = Math.min(e.y, minY);
    });
  }

  let deltaX = polyline.left - (minX - Math.max(minLineX - minHeadX, 0));
  let deltaY = polyline.top - (minY - Math.max(minLineY - minHeadY, 0));
  if (deltaX === deltaY && Math.abs(deltaX) + Math.abs(deltaY) <= updatePolyline.strokeWidth) return polyline;
  const newPoints = [];
  deltaX += updatePolyline.strokeWidth / 2;
  deltaY += updatePolyline.strokeWidth / 2;
  updatePolyline.points.map((e) => {
    if (e.corner) newPoints.push({ x: e.x + deltaX, y: e.y + deltaY, corner: e.corner });
    else newPoints.push({ x: e.x + deltaX, y: e.y + deltaY });
    return e;
  });
  const { canvas } = window;
  const index = getIndex(polyline);
  canvas.remove(polyline);

  const newPolyline = new fabric.Polyline(newPoints, {
    padding: 20,
    name: updatePolyline.name,
    fill: updatePolyline.fill,
    stroke: updatePolyline.stroke,
    strokeWidth: updatePolyline.strokeWidth,
    opacity: updatePolyline.opacity,
    strokeDashArray: updatePolyline.strokeDashArray,
    strokeLineCap: updatePolyline.strokeLineCap,
    toPort: updatePolyline.toPort,
    fromPort: updatePolyline.fromPort,
    toNode: updatePolyline.toNode,
    fromNode: updatePolyline.fromNode,
    toId: updatePolyline.toId,
    fromId: updatePolyline.fromId,
    hasControls: updatePolyline.hasControls,
    hasBorders: updatePolyline.hasControls,
    lockMovementX: updatePolyline.lockMovementX,
    lockMovementY: updatePolyline.lockMovementY,
    perPixelTargetFind: updatePolyline.perPixelTargetFind,
    destination: { x: updatePolyline.destination.x + deltaX, y: updatePolyline.destination.y + deltaY },
    isNotObj: updatePolyline.isNotObj,
    isOverContainer: updatePolyline.isOverContainer,
    originalName: updatePolyline.originalName,
    angle: updatePolyline.angle,
    id: updatePolyline.id,
    copyId: updatePolyline.copyId,
    objectCaching: false,
  });
  removeId(newPolyline.id);
  canvas.insertAt(newPolyline, index);
  return newPolyline;
}

export function highlightControl(controlName) {
  const { canvas } = window;
  switch (controlName) {
    case 'Port_1':
      state4Port.Port_1 = true;
      break;
    case 'Port_2':
      state4Port.Port_2 = true;
      break;
    case 'Port_3':
      state4Port.Port_3 = true;
      break;
    case 'Port_4':
      state4Port.Port_4 = true;
      break;
    default:
      break;
  }
  const activeOBJ = canvas.getActiveObject();
  canvas.discardActiveObject();
  canvas.requestRenderAll();
  canvas.setActiveObject(activeOBJ);
}

export function turnOffHighLightPolyline() {
  if (highlightObj.copyId) {
    highlightObj.set({ copyId: null });
    highlightObjId.id = null;
    const { canvas } = window;
    canvas.remove(highlightObj);
    listLabel.map((e) => {
      canvas.remove(e);
      return e;
    });
    listLabel = [];
    canvas.requestRenderAll();
  }
}

export function highlightPolyline(target) {
  const { canvas } = window;
  if ((highlightObj.copyId && highlightObj.copyId === target.id) || target.isNotObj) return;
  if (highlightObj.copyId) turnOffHighLightPolyline();
  const isUpdateLine = isModifiableArrowLine(target);
  let updatedPolyline;
  if (isUpdateLine) updatedPolyline = target._objects.find((o) => o?.name === FABRIC_CUSTOM_OBJECT.modifiableArrowLine);
  else updatedPolyline = target;
  if (isUpdateLine) {
    const linePath = getPathStringFromPoints(
      updatedPolyline.points,
      updatedPolyline.lineShape,
      updatedPolyline.shapeBorderRadius,
    );
    highlightObj = new fabric.Path(linePath, {
      name: 'highlightPolyline',
      fill: '',
      strokeWidth: updatedPolyline.strokeWidth + 2,
      stroke: isUpdateLine ? '#cce2fa' : '#096dd9',
      originX: 'center',
      originY: 'center',
      hasControls: false,
      hasBorders: false,
      selectable: false,
      isNotObj: true,
      shapeBorderRadius: 5,
      angle: updatedPolyline.angle,
      copyId: target.id,
    });
  } else {
    highlightObj = new fabric.Polyline(updatedPolyline.points, {
      name: 'highlightPolyline',
      isNotObj: true,
      fill: '',
      strokeWidth: updatedPolyline.strokeWidth + 2,
      stroke: isUpdateLine ? '#cce2fa' : '#096dd9',
      hasBorders: false,
      hasControls: false,
      selectable: false,
      angle: updatedPolyline.angle,
      copyId: target.id,
    });
  }
  highlightObjId.id = target.id;
  const index = getIndex(target);
  canvas.insertAt(highlightObj, index);
  canvas.getObjects().forEach((e) => {
    if (e.polylineId === target.id) {
      e.setCoords();
      const highlightLabel = new fabric.Rect({
        name: 'highlightLabel',
        isNotObj: true,
        left: e.left,
        top: e.top,
        width: e.width,
        height: e.height,
        stroke: '#096dd9',
        fill: 'transparent',
        strokeWidth: 2,
        hasBorders: false,
        hasControls: false,
        selectable: false,
      });
      const indexLabel = getIndex(e);
      canvas.insertAt(highlightLabel, indexLabel);
      listLabel.push(highlightLabel);
    }
    return e;
  });
  canvas.requestRenderAll();
}
export function turnOffHighLightPolylineSelected() {
  if (highlightObjSelected.copyId) {
    highlightObjSelected.set({ copyId: null });
    polylineSelectedId.id = null;
    const { canvas } = window;
    canvas.remove(highlightObjSelected);
    listLabelSelected.forEach((e) => {
      canvas.remove(e);
    });
    listLabelSelected = [];
    canvas.requestRenderAll();
  }
}

export function highlightPolylineSelected(polyline) {
  let target = null;

  window.canvas.getObjects().forEach((e) => {
    if (
      (e.id === polyline.id || e.id === polyline.copyId) &&
      !e.isNotObj &&
      (e.type === FABRIC_CUSTOM_OBJECT.polyline || isModifiableArrowLine(e))
    )
      target = e;
  });
  if (!target) return;

  const isUpdateLine = isModifiableArrowLine(target);

  if (isUpdateLine) updatePoints(target, target?.name);
  else updatePoints(target);

  const { canvas } = window;
  if ((highlightObjSelected.copyId && highlightObjSelected.copyId === target.id) || target.isNotObj) return;
  if (highlightObjSelected.copyId) turnOffHighLightPolylineSelected();
  let updatedPolyline;
  if (isUpdateLine) updatedPolyline = target._objects.find((o) => o?.name === FABRIC_CUSTOM_OBJECT.modifiableArrowLine);
  else updatedPolyline = target;
  if (isUpdateLine) {
    const linePath = getPathStringFromPoints(
      updatedPolyline.points,
      updatedPolyline.lineShape,
      updatedPolyline.shapeBorderRadius,
    );
    highlightObjSelected = new fabric.Path(linePath, {
      name: 'highlightPolyline',
      fill: '',
      strokeWidth: updatedPolyline.strokeWidth + 2,
      stroke: isUpdateLine ? '#cce2fa' : '#096dd9',
      originX: 'center',
      originY: 'center',
      hasControls: false,
      hasBorders: false,
      selectable: false,
      isNotObj: true,
      shapeBorderRadius: 5,
      angle: updatedPolyline.angle,
      copyId: target.id,
    });
  } else {
    highlightObjSelected = new fabric.Polyline(updatedPolyline.points, {
      name: 'highlightPolyline',
      isNotObj: true,
      fill: '',
      strokeWidth: updatedPolyline.strokeWidth + 2,
      stroke: isUpdateLine ? '#cce2fa' : '#096dd9',
      hasBorders: false,
      hasControls: false,
      selectable: false,
      angle: updatedPolyline.angle,
      copyId: target.id,
    });
  }
  polylineSelectedId.id = target.id;
  const index = getIndex(target);
  canvas.insertAt(highlightObjSelected, index);

  canvas.getObjects().forEach((e) => {
    if (e.polylineId === target.id) {
      e.setCoords();
      const highlightLabel = new fabric.Rect({
        name: 'highlightLabel',
        isNotObj: true,
        left: e.left,
        top: e.top,
        width: e.width,
        height: e.height,
        stroke: '#096dd9',
        fill: 'transparent',
        strokeWidth: 1,
        hasBorders: false,
        hasControls: false,
        angle: e.angle,
        selectable: false,
      });
      canvas.insertAt(highlightLabel, index);
      listLabelSelected.push(highlightLabel);
    }
  });
  canvas.setActiveObject(target);
}

export function cleanObject() {
  const { canvas } = window;
  canvas.getObjects().map((obj) => {
    if (obj.isNotObj) {
      canvas.remove(obj);
    }
    if (obj.type === FABRIC_CUSTOM_OBJECT.polyline) obj.set({ padding: 20 });
    obj.setCoords();
    return obj;
  });
  canvas.requestRenderAll();
}

export function turnOffHighLightPort(target) {
  if (target && (state4Port.Port_1 || state4Port.Port_2 || state4Port.Port_3 || state4Port.Port_4)) {
    state4Port.Port_1 = false;
    state4Port.Port_2 = false;
    state4Port.Port_3 = false;
    state4Port.Port_4 = false;
    const { canvas } = window;
    const activeObj = canvas.getActiveObject();
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    canvas.setActiveObject(activeObj);
  }
}

export function polylineModified(polyline) {
  const isUpdateLine = isModifiableArrowLine(polyline);
  let newPolyline;
  let updatedPolyline;
  newPolyline = updatePoints(polyline, polyline?.name);
  if (isUpdateLine)
    updatedPolyline = newPolyline._objects.find((o) => o.name === FABRIC_CUSTOM_OBJECT.modifiableArrowLine);
  else updatedPolyline = polyline;

  if (updatedPolyline.strokeWidth + 2 === highlightObjSelected.strokeWidth) return;
  turnOffHighLightPolylineSelected();
  turnOffHighLightPolyline();
  updateConnector(newPolyline);
  highlightPolylineSelected(newPolyline);
  deleteControl();
  addingControlPoints(newPolyline);
}
